import { WebViewerInstance } from '@pdftron/webviewer';
import { createSlice } from '@reduxjs/toolkit';

import { IDraft } from '../../interfaces/IDraft';
import { draftApi } from '../../redux/services/draftApi';
import type { RootState } from '../../redux/store';

const initialState = {
  fileLink: null,
  draft: null,
  instance: null,
} as {
  fileLink: string | null;
  draft: IDraft | null;
  instance: WebViewerInstance | null;
};

const draftSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setInstance: (state, action) => {
      state.instance = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      draftApi.endpoints.getDocument.matchFulfilled,
      (state, action) => {
        state.fileLink = action.payload.presigned_url;
      }
    );
    builder.addMatcher(
      draftApi.endpoints.getDraft.matchFulfilled,
      (state, action) => {
        state.draft = action.payload;
      }
    );
  },
});

export const { setInstance } = draftSlice.actions;

export default draftSlice.reducer;

export const selectIsAuthenticated = (state: RootState) =>
  state.auth.isAuthenticated;
